<template>
	<nav class="navigation navbar navbar-default ">
		<div class="container-fluid justify-content-center ">
			<div class="navbar-header d-flex  ">
				<a
					href="#homepage"
					id="menuTextLeft"
					class="option1 navbar-text navbar-left px-3"
					>Home
				</a>
				<a
					href="#about-me"
					id="menuTextLeft"
					class="option2 navbar-text navbar-left px-3"
				>
					About Me
				</a>
				<a
					href="#work"
					id="menuTextLeft"
					class="option6 navbar-text navbar-left px-3"
				>
					Work
				</a>
				<a
					href="#myBlog"
					id="menuTextLeft"
					class="option6 navbar-text navbar-left px-3"
				>
					Blogs
				</a>
				<a
					href="mailto:ritesh.parmar1096@gmail.com"
					id="menuTextLeft"
					class="option6 navbar-text navbar-left px-3"
				>
					Get in Touch!
				</a>
			</div>
		</div>
	</nav>
</template>

<script>
export default {};
</script>

<style scoped>
a {
	text-decoration: none;
}
#menuTextLeft {
	color: #333333;
	font-size: 16px;
	font-weight: 550;
}

.navigation {
	background: none !important;
	border: none;
	position: sticky;
	/* visibility: hidden; */
}
</style>
